import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import messages from '../../messages';

export const ADMIN_DELETION_REASON_CODE = 'other';
export const ADMIN_DELETION_COMMENT = 'Deleted by admin via Backstage';

const deleteCandidate = async ({ uuid }: { uuid: string }) => {
  const { data } = await putRequest<RequestSimplifiedData>(
    API.PUT.markAccountDeleted(uuid),
    {
      deletion_reason: {
        reason_code: ADMIN_DELETION_REASON_CODE,
        comment: ADMIN_DELETION_COMMENT,
      },
    },
  );
  return data;
};

export const useDeleteCandidate = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteCandidate,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.deleteSuccessMessage));
      client.invalidateQueries({ queryKey: [QUERY_KEYS.ALL_CANDIDATES] });
    },
    onError: handleError,
  });
};
